export const MORTGAGE_COACH_INTEGRATION = 'mortgage_coach_integration';
export const LOAN_OFFICER_EXPIRING_LOCK_NOTIFICATION =
  'loan_officer_expiring_lock_notification';
